<div class="main">
  <div class="mainSection">
    <div class="header">
      <div class="title">
        <div class="label" *ngIf="!selectedStatus.is_deleted">
          {{'BIDORDER.mybids' | translate}}
        </div>
        <div class="label" *ngIf="selectedStatus.is_deleted">
          {{'BIDORDER.mybids_deleted' | translate}}
        </div>
        <div class="help">
          <!-- <app-help [helpData]="helpData"></app-help> -->
        </div>
      </div>
      <div class="status">
        <span>
          {{'ORDER_DASHBOARD.status' | translate}}:
        </span>
      </div>
      <div class="dropdown">
        <mat-select class="inputSelect" [(value)]="selectedStatus" style="color: #fff;">
          <mat-option *ngFor="let status of statusArray" [value]="status" (click)="selectStatus(status)">
            {{status.status}}
          </mat-option>
        </mat-select>
      </div>
      <div class="refresh" (click)="paginator.pageIndex = 0;getOrders()"><i class="material-icons">refresh</i></div>
    </div>
    <div class="orders">
      <div class="load">

        <ng-container *ngIf="isMobileView">
          <ng-container *ngIf="ordersList && ordersList.filteredData.length; else noOrders">
            <div class="mobile-card" *ngFor="let element of ordersList.filteredData">
              <div class="card-header">
                <div class="header-left">
                  <b>{{element.order}}</b>
                  <div *ngIf="element.is_bidding" class="bid-icon">
                    <img src="assets/bid.svg" class="bidHammerImg" alt="">
                  </div>
                </div>
              </div>
              <div class="card-content">

                <div class="card-row">
                  <b style="color: rgba(0,0,0,.54);margin-right: 15px;">{{'BIDORDER.shipper' | translate}}:</b>
                  <span style="font-weight: bold;">{{element.shipper.parent_name}} - {{element.shipper.name}}</span>
                </div>

                <div class="card-row">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.from' | translate}}:</div>
                  <div *ngFor="let pick of element.from; let i = index">
                    <div style="margin-left: 6px;">
                      <strong style="color: #0B7D2E;">P{{i + 1}}</strong> - {{pick.loc_id.name}}, {{pick.loc_id.city}}
                      <div *ngIf="i === 0" style="font-size: 10px; color: #757575;text-align: end;">
                        {{'BIDORDER.pickupDate' | translate}}: {{element.pickDate}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-row">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.to' | translate}}:</div>
                  <div *ngFor="let delivery of element.to; let i = index">
                    <div style="margin-left: 6px;">
                      <b style="color: #D8511F;">D{{i + 1}}</b> - {{delivery.loc_id.name}}, {{delivery.loc_id.city}}
                    </div>
                  </div>
                </div>

                <div class="card-row">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.vehicleType' | translate}}:</div>
                  <span style="font-weight: bolder;">{{ element.vehicle?.name || element.vehicle }}</span>
                </div>
                
                <div class="card-row" *ngIf="!element.weight_based">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.no_of_vehicles' | translate}}:</div>
                  <span>{{element.req_no_of_vehicles}}</span>
                  <span *ngIf="element.cancelled_vehicles" style="color: red;">
                    {{'BIDORDER.cancelled' | translate}}: {{element.cancelled_vehicles}}
                  </span>
                </div>

                <div class="card-row" *ngIf="element.weight_based">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.weight_requested' | translate}}:</div>
                  <span>{{element.weight_based.pending}} {{element.uom | titlecase}}</span>
                </div>

                <div class="card-row" *ngIf="element.is_bidding">
                  <div style="color: rgba(0,0,0,.54);">
                    {{'BIDORDER.biddingEndTime' | translate}}:
                  </div>
                  <div style="font-size: 10px;display: flex;flex-direction: column;">
                    <span>{{element.bidding_end_date}}</span>
                    <span style="color: #757575; text-align: end;">{{element.readableDeadline}}</span>
                  </div>
                </div>

                <div class="card-row">
                  <div style="color: rgba(0,0,0,.54);">
                    {{'BIDORDER.bidStatus' | translate}}:
                  </div>
                  <span style="border-radius: 7px; padding: 4px 10px;" [ngStyle]="{'color': element.bid_status == 'won' ? '#0B7D2E' : element.bid_status == 'in_progress' ? '#631d50' : element.bid_status == 'closed' ? '#FF9800' : '#E54131', 'background-color': element.bid_status == 'won' ? '#E8F5E9' : element.bid_status == 'in_progress' ? '#F3E5F5' : element.bid_status == 'closed' ? '#FFF3E0' : '#FFEBEE'}">
                    {{element.bid_status_string}}
                  </span>
                </div>

                <div class="card-row">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.bidRate' | translate}} ({{currencySymbol}}):</div>
                  <span>{{element.lowest_bid_amount | numberFormat:element.lowest_bid_amount}}</span>
                </div>

                <div class="card-row" *ngIf="element.delete_reason">
                  <div style="color: rgba(0,0,0,.54);">{{'BIDORDER.reason' | translate}}:</div>
                  <span title="{{element.delete_reason}}" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis;">
                    {{element.delete_reason}}
                  </span>
                </div>
              </div>
              <div class="card-button" (click)="openAssignSideModal(element)">
                {{'BIDORDER.open' | translate}}
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isMobileView">
          <table mat-table *ngIf="ordersList && ordersList.filteredData.length;else noOrders" [dataSource]="ordersList"
          matSort (matSortChange)="sortOrderData($event)" class="orderTable">

          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <!-- Order  -->
              <div style="text-align: center;width: 100%;">

                <input type="text" [placeholder]="'BIDORDER.order' | translate" title="Order" [(ngModel)]="filterOrder"
                  (keyup)="searchFilter(filterOrder, 'order')" (click)="$event.stopPropagation()" class="formField" />
              </div>

            </th>
            <td mat-cell *matCellDef="let element">
              <div class="bidIcon">
                <img *ngIf="element.is_bidding" src="assets/bid.svg" class="bidHammerImg" alt="">
              </div>
              {{element.order}}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="organization">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
                    Organization
                    <input type="text" placeholder="Organization" title="Organization" (click)="$event.stopPropagation()" class="formField" />
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.organization.name}} </td>
                </ng-container> -->

          <ng-container matColumnDef="shipper">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <!-- Shipper -->
              <div style="text-align: center;width: 95%;">

                <input type="text" [placeholder]="'BIDORDER.shipper' | translate" [(ngModel)]="filterShipper"
                  title="Shipper" (keyup)="searchFilter(filterShipper, 'shipper')" (click)="$event.stopPropagation()"
                  class="formField" style="padding-left: 5px;" />
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <span style="font-weight: bold;">{{element.shipper.parent_name}} - </span> {{element.shipper.name}}
            </td>
          </ng-container>



          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">
                {{'BIDORDER.from' | translate}}
              </div>
              <!-- <input type="text" placeholder="From" title="From" (click)="$event.stopPropagation()" class="formField" /> -->
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngFor="let pick of element.from; let i=index; let onlyFirst = first">
                <strong style="color: #0B7D2E;">P{{i+1}}</strong> - {{pick.loc_id.name}} {{pick.loc_id.city}}<br>
                <div *ngIf="onlyFirst" style="font-size: 10px; color: #757575;">{{'BIDORDER.pickupDate' | translate}} :
                  {{element.pickDate}}</div>
                <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">
                {{'BIDORDER.to' | translate}}
              </div>
              <!-- <input type="text" placeholder="To" title="To" (click)="$event.stopPropagation()" class="formField" /> -->
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngFor="let delivery of element.to; let i=index">
                <b style="color: #D8511F;">D{{i+1}}</b> - {{delivery.loc_id.name}} - {{delivery.loc_id.city}}<br>
                <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
              </span>
            </td>
          </ng-container>


          <ng-container matColumnDef="vehicle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">
                {{'BIDORDER.vehicleType' | translate}}
              </div>
              <!-- <input type="text" placeholder="Vehicle" title="Vehicle" (click)="$event.stopPropagation()" class="formField" /> -->
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="element.vehicle.name">
                {{element.vehicle.name}}
              </div>
              <div *ngIf="!element.vehicle.name">
                {{element.vehicle}}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="req_no_of_vehicles">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">
                {{'BIDORDER.requested' | translate}}
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="vehicles" *ngIf="!element.weight_based">
                <div>
                  {{'BIDORDER.no_of_vehicles' | translate}}: {{element.req_no_of_vehicles}}
                </div>
                <div *ngIf="element.cancelled_vehicles" style="color: red;">
                  {{'BIDORDER.cancelled' | translate}}: {{element.cancelled_vehicles}}
                </div>

              </div>
              <div class="weight" *ngIf="element.weight_based">
                <span>{{'BIDORDER.weight_requested' | translate}}: {{element.weight_based.pending}} {{element.uom |
                  titlecase}}</span>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="deadline">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">

                {{'BIDORDER.biddingEndTime' | translate}}
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="element.is_bidding">
                {{element.bidding_end_date}}<br>
                <span class="fromNow">
                  {{element.readableDeadline}}
                </span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="bid_status">
            <th mat-header-cell *matHeaderCellDef class="customHeader">{{'BIDORDER.bidStatus' | translate}}</th>
            <td mat-cell *matCellDef="let element"
              [ngStyle]="{'color':element.bid_status == 'won' ? '#0B7D2E':element.bid_status == 'in_progress'? '#631d50':element.bid_status =='closed' ? '#FF9800':'#E54131'}">
              {{element.bid_status_string}} </td>
          </ng-container>

          <ng-container matColumnDef="costPerVehicle">
            <th mat-header-cell *matHeaderCellDef class="customHeader">{{'BIDORDER.bidRate' | translate}}
              ({{currencySymbol}}) </th>
            <td mat-cell *matCellDef="let element">{{element.lowest_bid_amount |
              numberFormat:element.lowest_bid_amount}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'BIDORDER.actions' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                <!-- <div class="button" (click)="$event.stopPropagation();showOrderDetails(element);" >{{'BIDORDER.view' | translate}}</div> -->

                <div class="button" style="background-color: #3c7715"
                  (click)="$event.stopPropagation();tabIndex = 0;openAssignSideModal(element);">{{'BIDORDER.open' |
                  translate}}</div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'BIDORDER.reason' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="
                  max-width: 100px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;" title="{{element.delete_reason}}"> {{element.delete_reason}} </td>
          </ng-container>


          <!-- Header row second group -->

          <!-- <ng-container matColumnDef="span-order">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>
      
                <ng-container matColumnDef="span-shipper">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>
      
                <ng-container matColumnDef="span-from">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>
      
                <ng-container matColumnDef="span-to">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
                </ng-container>
      
                <ng-container matColumnDef="span-vehicleType">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1"> </th>
                </ng-container>
      
                <ng-container matColumnDef="span-vehicle">
                  <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="2"> Vehicle </th>
                </ng-container>
      
                <ng-container matColumnDef="span-costPerVehicle">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="border customHeader"></th>
                </ng-container>
      
                <ng-container matColumnDef="span-status">
                  <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="border customHeader"></th>
                </ng-container>
      
                <tr mat-header-row
                  *matHeaderRowDef="['span-order', 'span-shipper', 'span-from', 'span-to', 'span-vehicleType', 'span-vehicle', 'span-costPerVehicle', 'span-status']">
                </tr> -->

          <tr mat-header-row *matHeaderRowDef="ordersDisplay; sticky: true;" style="font-weight: bold !important;"></tr>
          <tr mat-row (click)="$event.stopPropagation();openOrderDetails(row)"
            [ngClass]="{'highlightRows': selectedStatus.is_deleted == true,'highlightRow': (selectedOrderData)?row._id == selectedOrderData._id:false}"
            *matRowDef="let row; columns: ordersDisplay;" style="height: 65px; font-weight: bold;"></tr>
          </table>
        </ng-container>

        <mat-paginator [length]="(ordersList)? totalOrders:0" [showFirstLastButtons]="true"
          style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;" [pageSize]="25"
          [pageSizeOptions]="[5, 10, 25, 50, 100]" (page)="pageNavigate($event)"></mat-paginator>
      </div>
      <div class="semiTransparentBackground" [hidden]="!showStatusTab" [@fadeIn]></div>

      <div class="statusTab" *ngIf="showStatusTab" [@slideInOut]>
        <i class="material-icons" style="margin-top: 4px;"
          (click)="showStatusTab=0; selectedOrderData={}; clearBids()">clear</i>
        <div class="orderView" *ngIf="showOrderDetailsView==1">
          <div class="header">
            {{'BIDORDER.viewOrder' | translate}}
          </div>
          <div class="section">
            <div class="order-placed">{{'BIDORDER.order_placed' | translate}} :
              {{timeService.toShortDateTime(selectedOrderData.created_at)}}</div>
            <div class="stepper">
              <mat-vertical-stepper [selected]="selectedOrderAllLocationsData.length + 10" [linear]="true" #stepper>
                <mat-step [label]="locStep._id" [state]="locStep._id"
                  *ngFor="let locStep of selectedOrderAllLocationsData;let i = index">
                  <ng-template matStepLabel>{{locStep.loc_id.name}}</ng-template>
                  <div class="areaDetails">
                    {{locStep.loc_id.area}} <br>

                    <span class="dateTime">
                      <i class="material-icons" style="margin-right: 6px;margin-top: -5px">date_range</i>
                      {{changeDateFormat(locStep.date_time)}}
                    </span>

                  </div>

                </mat-step>
                <ng-template class="pickStep" *ngFor="let locStep of selectedOrderData.from;let i = index"
                  [matStepperIcon]="locStep._id">
                  <span style="font-size: 14px;">P{{i+1}}</span>
                </ng-template>
                <ng-template *ngFor="let locStep of selectedOrderData.to;let i = index" [matStepperIcon]="locStep._id">
                  <span class="dropStep" style="font-size: 14px;">D{{i+1}}</span>
                </ng-template>

              </mat-vertical-stepper>
            </div>
            <div class="documentSection" *ngIf="selectedOrderData.docs.length; else noDocs">
              <div class="documents" *ngFor="let item of selectedOrderData.docs">
                <a href="{{item.link}}" class="icon">
                  <img
                    *ngIf="item.extension == 'png' || item.extension == 'jpg' || item.extension == 'jpeg || item.extension == 'gif"
                    class="image" src="assets/image-icon.svg">
                  <img *ngIf="item.extension == 'pdf'" class="image" src="assets/PDF-icon.svg">
                  <img
                    *ngIf="item.extension == 'doc' || item.extension == 'csv' || item.extension == 'docx' || item.extension == 'txt' || item.extension == 'xlsx'"
                    class="image" src="assets/Doc-icon.svg">
                </a>
              </div>
            </div>

            <ng-template #noDocs>
              <div class="noDocs">
                {{'ORDER_DASHBOARD.noDocs' | translate}}
              </div>
            </ng-template>
            <div class="accessoriesSection" *ngIf="selectedOrderData.accessories.length; else noAccessories">
              <div class="heading">
                {{'ORDER_DASHBOARD.accessories' | translate}} :
              </div>
              <span class="data" *ngFor="let item of selectedOrderData.accessories; let ind = index;">
                {{item.name}}
                <span
                  *ngIf="selectedOrderData.accessories.length > 1 && ind != selectedOrderData.accessories.length-1">,
                </span>
              </span>
            </div>

            <ng-template #noAccessories>
              <div class="noDocs">
                {{'ORDER_DASHBOARD.noAccessories' | translate}}
              </div>
            </ng-template>
          </div>
        </div>
        <div class="assignDetails" *ngIf="showOrderDetailsView==0">
          <div class="statusHeader">
            <div class="status">Status</div>
            <mat-grid-list cols="3" rowHeight="3:1">
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==0}" (click)="tabIndex = 0;">
                <span>{{'BIDORDER.biddingStatus' | translate}}</span>
              </mat-grid-tile>
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==1}" (click)="tabIndex = 1;">
                <span>{{'BIDORDER.assignmentStatus' | translate}}</span>
              </mat-grid-tile>
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==2}" (click)="tabIndex = 2; getShipmentStatus();">
                <span>{{'BIDORDER.shipmentStatus' | translate}}</span>
              </mat-grid-tile>
            </mat-grid-list>
          </div>


          <div class="biddingData" *ngIf="selectedOrderData.is_bidding  && tabIndex == 0 ">
            <div *ngIf="bidType!=='tender' && bidType!=='rfq'" class="biddingLow"
              [ngStyle]="{'background-color':(lastBids.order_lowest == lastBids.last_bid && bid_status != 'lost')? '#0B7D2E':'#E54131'}">
              <span>{{ 'BIDORDER.lowestBid' | translate}} : {{currencySymbol}} {{lastBids.order_lowest
                |numberFormat:lastBids.order_lowest}}</span>
              <span *ngIf="lastBids.last_bid != 0" style="margin-left: 25px;float: right;">{{'BIDORDER.myLastBid' |
                translate}} : {{currencySymbol}} {{lastBids.last_bid |numberFormat:lastBids.last_bid}}</span>
            </div>
            <div *ngIf="reqest_sent && !allow_bid && this.bidType === 'rfq' && bid_status == 'in_progress'" align="end" style="color:white; margin-top: 10px; background-color: #D8511F; padding: 10px;
              font-size: 12px;height: 18px;display: flex; justify-content: center; align-items: center;">
              {{'BIDORDER.requestSent' | translate}} - {{currencySymbol}} {{unapproved_bid_amount |numberFormat:unapproved_bid_amount}}
            </div>

            <div *ngIf="this.rejectSuccess && !this.allow_bid && !reqest_sent && unapproved_bid_amount != undefined && this.bidType === 'rfq' && bid_status == 'in_progress'" align="end" style="color:white; margin-top: 10px; background-color: #D8511F; padding: 10px;
              font-size: 12px;height: 18px;display: flex; justify-content: center; align-items: center;">
              {{'BIDORDER.requestFailed' | translate}} - {{currencySymbol}} {{unapproved_bid_amount |numberFormat:unapproved_bid_amount}}
            </div>

            <div *ngIf="this.approveSuccess && this.allow_bid && unapproved_bid_amount != undefined && bidType === 'rfq' && bid_status == 'in_progress' " align="end" style="color:white; margin-top: 10px; background-color: #0B7D2E; padding: 10px;
              font-size: 12px;height: 18px;display: flex; justify-content: center; align-items: center;">
              {{'BIDORDER.requestApproved' | translate}} - {{currencySymbol}} {{unapproved_bid_amount |numberFormat:unapproved_bid_amount}}
            </div>

            <div class="bidForm" *ngIf="bid_status == 'in_progress' && bidType!=='tender' " >
              <mat-card>
                <mat-checkbox [(ngModel)]="bidData.auto" (change)="showManualDialog($event)" *ngIf="bidType!=='rfq'">{{'BIDORDER.autoBid' |
                  translate}}</mat-checkbox>

                <div class="amount">
                  <mat-form-field class="bidInputs">
                    <input matInput type="number" placeholder="Amount {{currencySymbol}}" name="amount"
                      [(ngModel)]="bidData.amount" [disabled]='disable_input || (bidType === "rfq" && allow_bid && !reqest_sent)'>
                    <mat-hint *ngIf="max_bid_amount && bidType !== 'rfq'" align="end">{{'BIDORDER.lessAmount' | translate}}
                      {{currencySymbol}} {{max_bid_amount |numberFormat:max_bid_amount}}</mat-hint>
                    <mat-hint *ngIf="!max_bid_amount && bidType !== 'rfq'" align="end" style="color:#D8511F">{{'BIDORDER.limit' | translate}}
                    </mat-hint>
                  </mat-form-field>

                </div>
                <div class="floor_amount" [hidden]="!bidData.auto">
                  <mat-form-field class="bidInputs">
                    <input type="number" matInput placeholder="Floor Amount {{currencySymbol}}" name="floor_amount"
                      [(ngModel)]="bidData.floor_amount" [disabled]='disable_input'>
                  </mat-form-field>
                </div>
                <div class="decrement_amount" [hidden]="!bidData.auto">
                  <mat-form-field class="bidInputs">
                    <input type="number" matInput placeholder="Decrement Amount {{currencySymbol}}"
                      name="decrement_amount" [(ngModel)]="bidData.decrement_amount" [disabled]='disable_input'>
                    <mat-hint align="end" *ngIf="bidType !== 'rfq'">{{'BIDORDER.decrementAmount' | translate}} {{currencySymbol}} {{min_bid_diff
                      |numberFormat:min_bid_diff}}</mat-hint>

                  </mat-form-field>
                </div>
                <div class="reason-input" *ngIf="this.bidType === 'rfq' && !this.allow_bid && !reqest_sent">
                  <input style="width: 95%; padding: 6px; margin-bottom: 15px; font-size: 14px;outline: none;" type="text" id="reason" [(ngModel)]="reason" placeholder="Enter Reason for Request" required />
                </div>
                <div class="bidbutton" (click)="bid()"
                  [ngStyle]="{ 'background-color':disable_input ? '#dddddd' : '#631d4f' }" *ngIf="this.bidType !== 'rfq' || (this.bidType === 'rfq' && this.allow_bid)">
                  {{'BIDORDER.bid' | translate}}
                </div>
                <div class="bidbutton" (click)="bidRequest()"
                  [ngStyle]="{ 'background-color':disable_input ? '#dddddd' : '#631d4f' }" *ngIf="this.bidType === 'rfq' && !this.allow_bid && !reqest_sent">
                  {{'BIDORDER.request' | translate}}
                </div>

              </mat-card>
            </div>
            <div *ngIf="bid_status === 'won'">
              <div class="noVersions" style="padding-top: 20px;text-align: center; color:#0B7D2E">
                {{'BIDORDER.wonBid' | translate}}
              </div>
            </div>
            <div *ngIf="bid_status === 'lost'">
              <div class="noVersions" style="padding-top: 20px;text-align: center;color:#D8511F">
                {{'BIDORDER.lostBid' | translate}}
              </div>
            </div>
            <div *ngIf="bid_status === 'closed'">
              <div class="noVersions" style="padding-top: 20px;text-align: center;color:#FF9800">
                {{'BIDORDER.bidClosed' | translate}}
              </div>
            </div>

            <div class="bidTrails" [ngStyle]="{'height': bidData.auto? 'calc(100vh - 470px)': 'calc(100vh - 350px)'}">
              <mat-card style="padding: 10px 0px;">
                <div class="biddingTable" *ngIf="lastBids.bids.length;else noBids">
                  <table mat-table [dataSource]="lastBids.bids" class="biddingHeader">
                    <ng-container matColumnDef="slno">
                      <th mat-header-cell *matHeaderCellDef class="biddingHeader"
                        style="word-wrap: break-word; width: 60px;">{{'BIDORDER.bidNo' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="width: 60px; word-wrap: break-word;">
                        {{element.slno}} </td>
                    </ng-container>

                    <ng-container matColumnDef="datetime">
                      <th mat-header-cell *matHeaderCellDef class="biddingHeader"> {{'BIDORDER.date' | translate}} </th>
                      <td mat-cell *matCellDef="let element" style="width: 60px;"> {{element.datetime}} </td>
                    </ng-container>

                    <ng-container matColumnDef="bid_amt">
                      <th mat-header-cell *matHeaderCellDef class="biddingHeader">{{'BIDORDER.bidAmount' | translate}}
                        ({{currencySymbol}}) </th>
                      <td mat-cell *matCellDef="let element" style="width: 60px;"> {{element.bid_amt
                        |numberFormat:element.bid_amt}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="lastBidColumns; sticky: true"
                      style="font-weight: bold !important;"></tr>
                    <tr mat-row *matRowDef="let row; columns: lastBidColumns;"></tr>
                  </table>
                </div>
                <ng-template #noBids>
                  <div class="noVersions" style="padding-top: 30px;text-align: center;">
                    {{'BIDORDER.noBids' | translate}}
                  </div>
                </ng-template>
              </mat-card>
            </div>
          </div>

          <div class="assignmentData" *ngIf="tabIndex == 1">
            <div class="statusBody">
              <div class="assignmentTable">
                <div class="table" *ngIf="bid_status=== 'won'">
                  <table style="border-top: solid 1px #d3d3d3;" mat-table #assignmentTable class="atable"
                    [dataSource]="assignmentDataSource" class="mat-elevation-z8">

                    <!--- Note that these columns can be defined in any order.
                                    The actual rendered columns are set as a property on the row definition" -->


                    <!-- Name Column -->
                    <ng-container matColumnDef="requested">
                      <th mat-header-cell *matHeaderCellDef>
                        <img src="assets/Request.svg" alt="">
                        <div>{{'BIDORDER.requested' | translate}}</div>
                        <div class="weight" *ngIf="selectedOrderData.bidding_type == 'weight'">
                          {{'BIDORDER.weight' | translate}} ({{selectedOrderData.uom}})
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div *ngIf="selectedOrderData.bidding_type != 'weight'">
                          {{element.requested}}
                        </div>
                        <div *ngIf="selectedOrderData.bidding_type == 'weight'">
                          {{selectedOrderData.weight_based.total}}
                        </div>
                      </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="accepted">
                      <th mat-header-cell *matHeaderCellDef>
                        <img src="assets/Accepted.svg" alt="">
                        <div>{{'BIDORDER.accepted' | translate}}</div>
                        <div class="weight" *ngIf="selectedOrderData.bidding_type == 'weight'">
                          {{'BIDORDER.weight' | translate}} ({{selectedOrderData.uom}})
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div *ngIf="selectedOrderData.bidding_type != 'weight'">
                          {{element.accepted}}
                        </div>
                        <div *ngIf="selectedOrderData.bidding_type == 'weight'">
                          {{selectedOrderData.weight_based.completed}}
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="cancelled">
                      <th mat-header-cell *matHeaderCellDef>
                        <img src="assets/Cancelled.svg" alt="">
                        <div>{{'ORDER_DASHBOARD.cancelled' | translate}}</div>
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.cancelled_vehicles}} </td>
                    </ng-container>

                    <ng-container matColumnDef="assigned">
                      <th mat-header-cell *matHeaderCellDef>
                        <img src="assets/Assigned.svg" alt="">
                        <div>{{'BIDORDER.assigned' | translate}}</div>
                        <div class="weight" *ngIf="selectedOrderData.bidding_type == 'weight'">
                          {{'BIDORDER.weight' | translate}} ({{selectedOrderData.uom}})
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div *ngIf="selectedOrderData.bidding_type != 'weight'">
                          {{element.assigned}}
                        </div>
                        <div *ngIf="selectedOrderData.bidding_type == 'weight'">
                          {{selectedOrderData.weight_based.assigned || 0}}
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="deadline">
                      <th mat-header-cell *matHeaderCellDef>
                        <img src="assets/Deadline.svg" alt="">
                        <div>{{'BIDORDER.deadline' | translate}}</div>
                      </th>
                      <!-- <td mat-cell *matCellDef="let element">
                                  {{element.deadline}}
                                </td> -->
                      <td mat-cell *matCellDef="let element"
                        [ngStyle]="{'color':!element.disableAssign ? '#e54031':'#000'}">
                        <span *ngIf="element.assignmentDeadline" style="font-size: 10px;"
                          [ngStyle]="{'color':!element.disableAssign ? '#e54031':'#000'}">{{'BIDORDER.assignBefore' |
                          translate}}<br /></span>
                        {{element.assignmentDeadline}}
                      </td>
                    </ng-container>
                    <!-- Symbol Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef> {{'BIDORDER.action' | translate}} </th>
                      <td mat-cell *matCellDef="let element">
                        <div class="buttons">
                          <div class="button"
                            *ngIf="(element.accepted != 0) || (selectedOrderData.bidding_type == 'weight')"
                            (click)="((element.disableAssign && element.to_be_assigned > 0) || (selectedOrderData.bidding_type == 'weight' && selectedOrderData.weight_based.pending > 0)) ? openAssignModal(element) : ''"
                            [ngStyle]="{'background-color':((element.disableAssign && element.to_be_assigned > 0) || (selectedOrderData.bidding_type == 'weight' && selectedOrderData.weight_based.pending > 0)) ? '#3c7715':'#c8cdd9'}">
                            Assign</div>
                          <!-- <div class="button"  (click) = "openAssignModal(element)"  style = "background-color: #3c7715" (click) = "openAssignModal(element)" >Assign</div> -->
                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="assignmentColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: assignmentColumns;"></tr>
                  </table>
                </div>

              </div>
              <div *ngIf="bid_status === 'in_progress'">
                <div class="noVersions" style="padding-top: 30px;text-align: center;color:#631d50">
                  {{'BIDORDER.biddingProgress' | translate}}
                </div>
              </div>
              <div *ngIf="bid_status === 'lost'">
                <div class="noVersions" style="padding-top: 30px;text-align: center; color:#D8511F">
                  {{'BIDORDER.lostBid' | translate}}
                </div>
              </div>
              <div *ngIf="bid_status === 'canceled'">
                <div class="noVersions" style="padding-top: 30px;text-align: center; color:#D8511F">
                  {{'BIDORDER.orderCancelled' | translate}}
                </div>
              </div>
              <div *ngIf="bid_status === 'closed'">
                <div class="noVersions" style="padding-top: 30px;text-align: center; color:#FF9800">
                  {{'BIDORDER.bidClosed' | translate}}
                </div>
              </div>

            </div>
          </div>



          <div class="statusTable" *ngIf="tabIndex == 2">
            <div class="tabs">
              <mat-grid-list cols="3">
                <mat-grid-tile [ngClass]="{tabSelected :tab == 0}" (click)="tab=0;changeTab();">
                  <!--[ngStyle]="{'background-color':tab == -1? '#2f3b91':'#ffffff', 'color':tab == -1? '#ffffff':'#2f3b91'}"-->
                  <div class="iconLabel">
                    <img [hidden]="tab == 0" src="assets/Assigned.svg" alt="">
                    <img *ngIf="tab == 0" src="assets/Assigned – White.svg" alt="">
                    <div class="statusLabel">{{'BIDORDER.assigned' | translate}}</div>

                  </div>
                </mat-grid-tile>
                <mat-grid-tile [ngClass]="{tabSelected :tab == 1}" (click)="tab =1;changeTab();">
                  <div class="iconLabel">
                    <img [hidden]="tab == 1" src="assets/InTransit.svg" alt="">
                    <img *ngIf="tab == 1" src="assets/InTransit – White.svg" alt="">
                    <div class="statusLabel">{{'BIDORDER.inTransit' | translate}}</div>

                  </div>
                </mat-grid-tile>
                <mat-grid-tile [ngClass]="{tabSelected :tab == 2}" (click)="tab =2;changeTab();">
                  <div class="iconLabel">
                    <img [hidden]="tab == 2" src="assets/Completed.svg" alt="">
                    <img *ngIf="tab == 2" src="assets/Completed – White.svg" alt="">
                    <div class="statusLabel">{{'BIDORDER.completed' | translate}}</div>

                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
            <div class="tableContent">
              <table mat-table *ngIf="shipmentStatusArray.length;else noShipments" [dataSource]="shipmentStatusArray">
                <ng-container matColumnDef="SIN">
                  <th mat-header-cell *matHeaderCellDef>{{'BIDORDER.shipments' | translate}}</th>
                  <td mat-cell *matCellDef="let element">{{element.SIN}}</td>
                </ng-container>
                <ng-container matColumnDef="shipper">
                  <th mat-header-cell *matHeaderCellDef>{{'BIDORDER.shipperName' | translate}}</th>
                  <td mat-cell *matCellDef="let element">{{element.shipper}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="shipmentsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns:shipmentsColumns;"></tr>
              </table>
              <ng-template #noShipments>
                <div class="noShipments" style="padding-top: 30px; text-align: center;">
                  {{'BIDORDER.noShipments' | translate}}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showLoader" class="loader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <ng-template #noOrders>
        <div class="noOrders" style="padding: 30px; text-align: center;">
          {{'BIDORDER.noOrders' | translate}}
        </div>
      </ng-template>
    </div>

  </div>
  <ng-template #switchToManualDialog>
    <div class="switchToManualDialog">
      <div class="header">
        {{'BIDORDER.warning' | translate}}
        <i class="material-icons" (click)="closeModal('no');">clear</i>
      </div>
      <div class="section">
        <h2 style="font-weight: normal;">{{'BIDORDER.manualBid' | translate}}</h2>
        <div class="submitButton" (click)="closeModal('yes');">
          <div class="button" style="background-color: #73235c;">
            {{'BIDORDER.yes' | translate}}
          </div>
        </div>
        <div class="submitButton" (click)="closeModal('no');" style="float: right;margin-right: 10px;">
          <div class="button" style="background-color: #a0a0a0;">
            {{'BIDORDER.no' | translate}}
          </div>
        </div>
      </div>
    </div>
  </ng-template>